/**
 * how to use
 *
 * `const f = fields<Interface>()`
 *
 * f.name -> got string {name}
 */
const nameof = <T>() => {
    return new Proxy(
        {},
        {
            get: function (_target, prop, _receiver) {
                return prop
            },
        },
    ) as {
        [P in keyof T]-?: P
    }
}

export default nameof
